module.exports = "/images/solucao_do_ano_2022.svg?c13e7cd824527b0558ca82e1d82c0411";